export default __webpack_public_path__ + "static/media/loss-analysis-step-3.38127784.gif";